export const REVIEW_TEXT = "Review";
export const CUSTOMIZE_TEXT = "Customize";
export const BOOK_TEXT = "Book";
